module.exports = __webpack_public_path__ + "static/3-2aeef42fea04c9eca1d22b78262433bd.png";